// extracted by mini-css-extract-plugin
export default {"btn":"AddTeamMemberButton_btn__71cV8","icon":"AddTeamMemberButton_icon__muF5r","text":"AddTeamMemberButton_text__fYY-w","disabled":"AddTeamMemberButton_disabled__c9Ov5"};